import * as _Footer from '#~/common/editor/footer/index.js';
import { logger } from '#~/logger/index.js';
import { useLatestFn } from '@studio/react-utils/hooks';
import type { ReactElement } from 'react';
import { useProducer, useStore } from '../store/hooks.js';
import { useWiring } from '../wiring.js';

/** Settings `<Footer>` component. */
export const Footer = (props: _Footer.Props): ReactElement => {
  const { isReady, isSaving } = useStore((µ) => µ.settings);
  const producer = useProducer();
  const wiring = useWiring();

  const handleBack = useLatestFn(() => {
    producer((draft) => {
      draft.panel--;
    });
  });

  const handleNext = useLatestFn(() => {
    if (!isReady || isSaving) {
      return;
    }

    wiring.handleCommit().catch((error) => {
      logger.critical(error);
    });
  });

  return (
    <_Footer.Root {...props}>
      <_Footer.Back onClick={handleBack} />
      <_Footer.Next
        disabled={!isReady || isSaving}
        label={isSaving ? 'Saving...' : 'Save and Finish'}
        onClick={handleNext}
      />
    </_Footer.Root>
  );
};
